import {React, useState, useEffect} from "react";
import iqraLogo from "../../Images/IQRA-logo.jpeg"; // Put your JAW logo path here
import schoolbg from "../../Images/school-1.jpeg";     // Put your background image path here
import { FaCheck, FaClock, FaCog, FaEnvelope, FaMapMarkerAlt, FaPhoneAlt, FaRegClock, FaSchool, FaTruck, FaWrench } from "react-icons/fa";
import facilityImg from '../../Images/eng-rec.jpg';
import school1 from '../../Images/school-1.jpeg';
import school2 from '../../Images/school-2.jpeg';
import school3 from '../../Images/school-3.jpeg';
import school4 from '../../Images/school-4.jpeg';
import school5 from '../../Images/school-5.jpeg';
// import school6 from '../../Images/school-1.jpeg';


const stats = [
  { value: "50+", label: "Heavy Vehicles" },
  { value: "24/7", label: "Support" },
  { value: "100%", label: "Safety Record" },
];



// Dummy gallery images (replace with your real imports)
const galleryImages = [
  school1,
  school2,
  school3,
  school4,
  school5,
  school1,
];


const growthTimeline = [
  {
    year: "2016 FOUNDATION",
    description: "Established with classes from Nursery to Grade 5",
  },
  {
    year: "CURRENT STATUS",
    description: "Full-fledged institution up to 10th Grade",
  },
];

const coreMissions = [
  {
    title: "ACADEMIC EXCELLENCE & MORAL VALUES",
    description: "Combining quality learning with ethical grounding",
  },
  {
    title: "CHARACTER DEVELOPMENT",
    description: "Fostering disciplined, responsible citizens",
  },
  {
    title: "EMPOWERMENT THROUGH EDUCATION",
    description: "Equipping students from all backgrounds",
  },
];

const qrCodeGangavathi = 'https://via.placeholder.com/150';

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'

const IQRA_SCHOOL = () => {
   // State for backend QR URLs for RANE sub-branches
        const [qrGangavathi, setQrGangavathi] = useState(null);
        
          // Fetch QR for RANE Hospet and Chitradurga on mount
          useEffect(() => {
            async function fetchQRs() {
              try {
                const res1 = await fetch(`${API_BASE_URL}/branchqrcode/IQRA School::Gangavathi`);
                if (res1.ok) {
                  const data1 = await res1.json();
                  setQrGangavathi(data1.qrCodeImageURL.startsWith('http') ? data1.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data1.qrCodeImageURL.replace(/^\//, '')}`);
                } else {
                  setQrGangavathi(null);
                }
    
              } catch {
                setQrGangavathi(null);
              }
            }
            fetchQRs();
          }, []);

  return (

<main className="">
  <section className="relative h-[390px] md:h-[370px] lg:h-[400px] w-full flex items-center justify-center overflow-hidden">
    {/* Background image */}
    <img
      src={schoolbg}
      alt="IQRA School Background"
      className="absolute inset-0 w-full h-[390px] md:h-[370px] lg:h-[400px] object-cover object-center"
      style={{ zIndex: 1 }}
    />
    {/* Backdrop overlay for readability */}
    <div className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30" style={{ zIndex: 2 }} />

    {/* Content Row */}
    <div className="relative z-10 flex flex-row items-center justify-center w-full max-w-6xl px-6 pt-4">
      {/* Heading Texts */}
      <div className="flex flex-col items-center justify-center  text-white w-full">
        {/* Logo (left) */}
        <img
          src={iqraLogo}
          alt="JAW Logo"
          className="w-32 h-32 object-contain drop-shadow-xl mt-8"
        />
        <h1 className="text-3xl md:text-5xl  font-bold tracking-tight leading-tight text-center sm:text-left drop-shadow-lg">
          Janatha Group<br />
        CSR INITIATIVE
        </h1>
        <div className=" bg-orange-800 p-1 rounded-xl mt-4 text-lg md:text-xl font-semibold text-center sm:text-left text-white drop-shadow-sm">
          IQRA PUBLIC SCHOOL - SINCE 2016
        </div>
      </div>
    </div>
  </section>


     {/* third second section */}
    <section className="max-w-7xl mx-auto px-4 py-10 flex flex-col lg:flex-row gap-4 items-start">
    {/* Left: Facility Photo */}
    <div className="flex-1 bg-white  px-6 py-6 flex flex-col justify-center">
      <div className="flex items-center gap-3 mb-3">
        <h2 className="text-2xl font-bold text-gray-900">
        Our Educational Journey
        </h2>
      </div>
      <p className="mt-4 text-gray-600 text-base leading-relaxed">
     At Janatha Group, we believe that true progress lies not only in economic success but in the upliftment of society through quality education rooted in values. With this vision, we founded Iqra Public School in 2016, under the aegis of the Iqra Foundation Trust.
      </p>
      <p className="mt-4 text-gray-600 text-base leading-relaxed">
     Located in Gangavathi, Iqra Public School was established to serve the educational needs of underprivileged and working-class families—offering affordable, value-based learning without compromising on quality. What began as a modest initiative with classes from Nursery to Grade 5 has now grown, by the grace of Allah, into a full-fledged institution offering education up to 10th Grade, with over 500 students and a dedicated staff of 30 teachers and 6 non-teaching personnel.
      </p>
    </div>
     {/* Right: Info Content */}
    <div className="flex-1">
      <img
        src={school3}
        alt="Facility"
        className="rounded-xl shadow-lg w-full object-cover min-h-[320px] max-h-[380px]"
      />
    </div>
  </section>

{/* new section */}
<section className="max-w-7xl mx-auto px-4 py-10 grid grid-cols-1 md:grid-cols-2 gap-8">
    {/* Left - Growth Timeline */}
    <div className="bg-white shadow-lg rounded-2xl p-8">
      <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6">
        OUR GROWTH TIMELINE
      </h2>
      <div className="flex flex-col gap-7 pl-2">
        {growthTimeline.map((item, idx) => (
          <div key={item.year} className="flex items-start gap-3">
            <span className="h-6 w-6 flex items-center justify-center">
              <span className="bg-blue-600 rounded-full w-4 h-4 block mt-1" />
            </span>
            <div>
              <div className="font-bold text-blue-700 text-base">{item.year}</div>
              <div className="text-gray-700 text-sm">{item.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
    {/* Right - Core Mission */}
    <div className="bg-white shadow-lg rounded-2xl p-8">
      <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-6">
        OUR CORE MISSION
      </h2>
      <div className="flex flex-col gap-7">
        {coreMissions.map((mission) => (
          <div key={mission.title} className="flex items-start gap-4">
            <div className="h-7 w-7 rounded-xl bg-blue-100 flex items-center justify-center mt-1">
              <FaCheck className="text-blue-600 text-lg" />
            </div>
            <div>
              <div className="font-bold  text-base">{mission.title}</div>
              <div className="text-gray-700 text-sm">{mission.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>


  {/* Gallery section */}
  <section className="max-w-7xl mx-auto px-4 py-12">
    <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">
      GALLERY
    </h2>
    <div className="grid grid-cols-2 md:grid-cols-3  gap-6">
      {galleryImages.map((img, idx) => (
        <div
          key={img}
          className="rounded-xl overflow-hidden shadow hover:shadow-lg transition aspect-w-4 aspect-h-3 bg-gray-200"
        >
          <img
            src={img}
            alt={`Gallery photo ${idx + 1}`}
            className="w-full h-[200px] object-cover"
          />
        </div>
      ))}
    </div>
  </section>

  {/* fifth section */}
   <section className="max-w-5xl mx-auto py-12 px-4 text-center">
    <div className="flex items-center justify-center gap-3 mb-5">
      <FaSchool className="text-blue-600 text-2xl" />
      <h2 className="text-2xl md:text-2xl font-bold text-gray-900">
       Building Values-Driven Future
      </h2>
    </div>
    <p className="max-w-3xl mx-auto text-gray-600 text-base md:text-lg mb-8">
    Join us in shaping brighter futures—one child at a time.
    </p>
  </section>
{/* bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white rounded-t-3xl p-8 shadow-2xl border border-gray-700 */}
  {/* last section */}
  <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900  rounded-t-3xl py-12 px-3 min-h-[540px]">
    <h2 className="text-3xl font-extrabold text-green-500 text-center mb-2 tracking-wide">
      GET IN TOUCH
    </h2>
    <div className="border-t-2 border-green-500 w-12 mx-auto mb-6" />
    <p className="text-center text-gray-200 mb-8 text-lg">
     We're here to help and answer any questions you might have.
    </p>

    <div className="flex flex-col lg:flex-row max-w-7xl mx-auto gap-8">
      {/* Left - Contact Information */}
      <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900  text-white rounded-2xl shadow-lg p-6 flex-1 min-w-[320px] flex flex-col gap-3 border border-green-300">
        <div className="flex items-center gap-2 mb-2">
          <FaMapMarkerAlt className="text-green-500 text-xl" />
          <h3 className="text-lg font-bold">CONTACT INFORMATION</h3>
        </div>
        {/* <div className="text-blue-300 mb-2 pl-7 text-md">Hospet Location</div> */}
        <div className="flex items-center gap-3 mt-3">
          <FaEnvelope className="text-green-400 text-xl" />
          <div>
            <div className="font-bold text-base leading-tight">EMAIL US</div>
            <a
              href="mailto:Iqrapublicschoolgvt@gmail.com
"
              className="text-green-300 underline text-md"
            >
              Iqrapublicschoolgvt@gmail.com

            </a>
          </div>
        </div>
        <div className="flex items-center gap-3 mt-4">
          <FaPhoneAlt className="text-green-400 text-xl" />
          <div>
            <div className="font-bold text-base leading-tight">CALL US</div>
            <a
              href="tel:+919931688993"
              className="text-green-300 underline text-md"
            >
             +91 9931688993
            </a>
          </div>
        </div>
      </div>

      {/* Right - Location Information & QR Code */}
      <div className="bg-gradient-to-br from-emerald-900/50 to-emerald-800/50  rounded-2xl shadow-lg p-6 flex-1 min-w-[340px] flex flex-col items-center lg:items-start border border-green-300">
        <h3 className="text-lg font-bold text-white mb-2 text-center lg:text-left">
          SCHOOL LOCATION
        </h3>
        <div className="text-green-200 text-center mb-5 text-sm">
          Scan the QR code for directions 
        </div>
        <div className="flex flex-col md:flex-row items-center gap-7 w-full">
           <img
              src={qrGangavathi || qrCodeGangavathi}
              alt="QR Code Hospet"
              className='w-40 h-40 rounded-lg bg-white'
            />
          <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900  border border-green-300 rounded-xl p-5 w-full text-white mt-6 md:mt-0">
            <div className="mb-1 font-semibold text-blue-100 text-base">LOCATION DETAILS:</div>
            <div className="text-sm leading-snug mb-3">
             IQRA public school, Julai Nagar, Tq. Gangavathi, Dist. Koppal - 583227
            </div>
            <div className="mb-1 font-semibold text-blue-100 text-base">LANDMARKS:</div>
            <ul className="list-disc pl-5 text-sm text-blue-100 space-y-1">
              <li>Near the main town center</li>
              <li>Adjacent to community park</li>
              <li>500m from Gangavathi bus stand</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
  </main>
);
}

export default IQRA_SCHOOL;
